<template>
  <div id="layout-wrapper">
    <TopBar @toggle-menu="toggleMenu" @toggle-right="toggleRightSidebar" />

    <SideBarComponent
      class="side-br"
      :type="layout.leftSidebarType"
      :width="layout.layoutWidth"
      @toggleMenu="toggleMenu"
    />

    <div class="main-content" @click="hideRightSidebar">
      <div class="page-content">
        <BContainer fluid>
          <slot />
        </BContainer>
      </div>

      <Footer v-if="false" />
    </div>

    <RightSideBar />
  </div>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { useLayoutStore } from '~/stores/layout'
 
import TopBar from '~/components/leyoutsCustomer/vertical/TopBar.vue'
import SideBarComponent from '~/components/leyoutsCustomer/common/SideBar.vue'
import Footer from '~/components/leyoutsCustomer/common/Footer.vue'
import RightSideBar from '~/components/leyoutsCustomer/common/RightSideBar.vue'

const router = useRouter()
const layoutStore = useLayoutStore()

// ako ti store ima state layout
const layout = computed(() => layoutStore.layout ?? layoutStore ?? {})

// init body attrs (kao created() u Nuxt2)
onMounted(() => {
  document.body.removeAttribute('data-layout')
  document.body.setAttribute('data-layout', 'vertical')
})

const toggleRightSidebar = () => {
  document.body.classList.toggle('right-bar-enabled')
}

const hideRightSidebar = () => {
  document.body.classList.remove('right-bar-enabled')
}

// da ne registruješ afterEach svaki put na klik
let removeAfterEach = null

const toggleMenu = () => {
 
  
  document.body.classList.toggle('sidebar-enable')

  const isDesktop = window.innerWidth >= 992

  // očisti prethodni hook ako postoji
  if (typeof removeAfterEach === 'function') {
    removeAfterEach()
    removeAfterEach = null
  }

  if (isDesktop) {
    document.body.classList.toggle('vertical-collpsed')

    removeAfterEach = router.afterEach(() => {
      document.body.classList.remove('sidebar-enable')
      document.body.classList.remove('vertical-collpsed')
    })
  } else {
    document.body.classList.remove('vertical-collpsed')

    removeAfterEach = router.afterEach(() => {
      document.body.classList.remove('sidebar-enable')
    })
  }

  // ako u store-u imaš isMenuCondensed
  if ('isMenuCondensed' in layoutStore) {
    layoutStore.isMenuCondensed = !layoutStore.isMenuCondensed
  }
}

onBeforeUnmount(() => {
  if (typeof removeAfterEach === 'function') removeAfterEach()
})
</script>
